/**
 * Pure helper for the `displayedConversations` memo in layout/Sidebar.tsx.
 *
 * Behavior-preserving extraction: only the memo BODY moved here. The
 * orchestrator retains the `useMemo` shell with its byte-identical dependency
 * array and calls this function inside it, so hook order and memoization
 * semantics are unchanged.
 */

import type { Conversation } from '@/types/conversations';

interface ComputeDisplayedConversationsArgs {
  tempConversationOrder: Conversation[] | null;
  userConversations: Conversation[];
  normalizedSearchQuery: string;
}

export function computeDisplayedConversations({
  tempConversationOrder,
  userConversations,
  normalizedSearchQuery,
}: ComputeDisplayedConversationsArgs): Conversation[] {
  const source = tempConversationOrder ?? userConversations;
  if (normalizedSearchQuery) {
    return source.filter((conversation) => (conversation.name || '').toLowerCase().includes(normalizedSearchQuery));
  }
  return source.slice(0, 7);
}
